import {Component, OnInit} from '@angular/core';
import {TableNumberService} from "../../core/http/table-number.service";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../core/auth/auth.service";
import {OrderService} from "../../core/http/order.service";

@Component({
  selector: 'app-table-number',
  templateUrl: './table-number.component.html',
  styleUrls: ['./table-number.component.scss']
})
export class TableNumberComponent implements OnInit {

  userRoles: string[] | null = [];
  tableNumber?: string;

  constructor(private tableNumberService: TableNumberService, private router: Router, private _snackBar: MatSnackBar, private authService: AuthService, private orderService: OrderService) {
    this.userRoles = this.authService.getUserRole();
  }

  ngOnInit() {
    this.orderService.clearOrder();
  }

  openNumpad(): void {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.openMobileNumpad();
    }
  }

  openMobileNumpad(): void {
    const inputElement = document.querySelector('.table-number-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.setAttribute('pattern', '\\d*');
      inputElement.setAttribute('inputmode', 'numeric');
      inputElement.focus();
    }
  }

  startOrder(voucher: boolean): void {
    if (voucher) {
      this.tableNumberService.setVoucher(true); // Save table number in the service
      this.tableNumberService.setTableNumber('55555');
      this.router.navigate(['/order']).then(r => {}); // Navigate to the /order route
    } else if (this.tableNumber) {
      this.tableNumberService.setTableNumber(this.tableNumber); // Save table number in the service
      this.router.navigate(['/order']).then(r => {}); // Navigate to the /order route
    } else {
      console.log('here i am')
      this._snackBar.open('Bitte Tischnummer eingeben', 'Schließen', {duration: 3000});
    }
  }

  showItem(requiredRole: string): boolean {
    if (this.userRoles) {
      return <boolean>this.userRoles!.includes(requiredRole);
    } else {
      this.userRoles = this.authService.getUserRole();
      return <boolean>this.userRoles!.includes(requiredRole);
    }
  }
}
